import React from 'react'
import moment from 'moment'
import useUserCourses from '../../../hooks/use-user-year-courses'
import mapConflicts from './map-conflicts'

const useCalendar = ({
    date,
    insertions = [],
    dateBackgroundColors,
    dateDotColors,
    dateLabelColors
}) => {
    const [ dateSelected, setDateSelected ] = React.useState(date)
    const momentSelected = moment(dateSelected, 'YYYY-MM-DD')

    const { courses: enrolledCourses, isLoading } = useUserCourses({ date: dateSelected })

    React.useEffect(() => {
        setDateSelected(date)
    }, [date])

    const courses = [...enrolledCourses, ...insertions]

    const onGetDateLabelColor = React.useCallback((date) => {
        const today = moment(date, 'YYYY-MM-DD')
        const isSelected = momentSelected.isSame(today, 'day')
        const isMomentToday = moment().isSame(today, 'day')
        if (isSelected) {
            return dateLabelColors.INVERTED
        }
        if (insertions.some(c => moment(c.date).isSame(today, 'day'))) {
            return dateLabelColors.INVERTED
        }
        if (enrolledCourses.some(c => moment(c.date).isSame(today, 'day'))) {
            return dateLabelColors.ACTIVE
        }
        if (isMomentToday) {
            return dateLabelColors.INVERTED
        }
        return dateLabelColors.DULL
    })

    const onGetDateDotColor = React.useCallback((date) => {
        let result
        const today = moment(date, 'YYYY-MM-DD')
        const isTodaySelected = momentSelected.isSame(today, 'day')
        const isMomentToday = moment().isSame(today, 'day')
        const coursesToday = courses.filter(c => moment(c.date).isSame(today, 'day'))

        if (coursesToday.length) {
            result =  dateDotColors.PRIMARY
            const conflicts = mapConflicts(coursesToday)
            if (conflicts.length) {
                result = dateDotColors.ALERT 
            }
        }
        if (result && (isTodaySelected || isMomentToday)) {
            result = dateDotColors.INVERTED
        }

        return result
    })

    const onGetDateBackgroundColor = React.useCallback((date) => {
        const today = moment(date, 'YYYY-MM-DD')
        const isTodaySelected = momentSelected.isSame(today, 'day')
        const isMomentToday = moment().isSame(today, 'day')
        const coursesToday = courses.filter(c => moment(c.date).isSame(today, 'day'))
        const conflicts = mapConflicts(coursesToday)

        if (isTodaySelected) {
            if (conflicts.length) {
                return dateBackgroundColors.ACTIVE_ALERT
            }
            return dateBackgroundColors.ACTIVE_PRIMARY
        } else {
            if (insertions.some(c => moment(c.date).isSame(today, 'day'))) {
                if (conflicts.length) {
                    return dateBackgroundColors.INACTIVE_ALERT
                }
                return dateBackgroundColors.INACTIVE_PRIMARY
            }
        }
        if (isMomentToday) {
            return dateBackgroundColors.INACTIVE_SECONDARY
        }
        return null
    })

    return {
        courses,
        isLoadingCalendar: isLoading,
        dateSelected,
        setDateSelected,
        onGetDateLabelColor,
        onGetDateDotColor,
        onGetDateBackgroundColor
    }
}

export default useCalendar
